import { reactive } from 'vue';
const state = reactive({
  notificationList: [],
});

// level should be 'high', 'medium', or 'low'

export default function useNotifications() {
  function addNotification(message, level, timeout) {
    const newID = Date.now();
    state.notificationList.push({ message, level, id: newID });

    if (timeout) {
      setTimeout(() => {
        removeNotification(newID);
      }, timeout * 1000);
    }
  }

  function removeNotification(id) {
    const index = state.notificationList.findIndex((alert) => alert.id === id);
    if (index === -1) return;
    state.notificationList.splice(index, 1);
  }

  return {
    notifications: state.notificationList,
    addNotification,
    removeNotification,
  };
}
